
import I18n from '@front/volcanion/utils/translation'

class Callbacks {

  static cancelListHandler(list_client_id, openDialog) {
    return async function cancelList() {
      openDialog('confirmation_cancel', {
        title: I18n.t('import.cancel'),
        description: I18n.t('import.cancel_confirm', { list_client_id })
      })
    }
  }
}

export default Callbacks

